import { Image, Locate, Mail, MapIcon, MapPin, Phone, User } from 'lucide-react';
import React from 'react';
import MoreOptionsCard from '../../../../Components/Utils/MoreOptionsCard';
import { Link } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import { FaUserTie } from 'react-icons/fa';

const TeamCard = ({ item, key, fetcher, data }) => {
  const canEdit = GetAccess("clients_edit");
  const canDel = GetAccess("clients_delete");

  return (
    <div key={key} className='w-full md:w-[30%] lg:w-[30%] bg-white p-4 rounded-xl shadow border border-gray-200 flex flex-col justify-between'>
      
      {/* Header */}
      <div className='flex items-start justify-between mb-4'>
  <div className='flex items-center gap-3'>
    <div className='w-20 h-20 rounded-lg overflow-hidden bg-gray-100 border border-gray-300 flex items-center justify-center'>
      {item.image?.file ? (
        <img src={item.image?.file} alt={item.name} className="w-20 h-20 object-cover rounded-md" />
      ) : (
        item?.name[0]
      )}
    </div>
    <div>
      <h3 className='text-lg font-semibold text-gray-800'>
        <Link to={`/teammember/team/view/${item.id}`} state={{ data: item }} className="hover:text-blue-600">
          {item.name}
        </Link>
      </h3>
      <p className='text-sm text-gray-500'>{item.designation}</p>
    </div>
  </div>

  {/* Right side MoreOptionsCard and status */}
  <div className="flex flex-col items-end gap-2">
    <MoreOptionsCard
      data={item}
      fetcher={fetcher}
      id={item.id}
      url={`/team/`}
      moduleName={"Team Member"}
      from={`/teammember/team`}
      editLink={canEdit ? `/teammember/team/edit/` : undefined}
      viewLink={`/teammember/team/view/`}
      removevalue={canDel ? item.name : undefined}
    />

    {/* Status Indicator */}
    <div className="flex items-center gap-1">
      <span
        className={`w-3 h-3 rounded-full ${
          item.status === 'Active' ? 'bg-green-500' : 'bg-red-500'
        }`}
      ></span>
     
    </div>
  </div>
</div>


      {/* Contact */}
      <div className='space-y-2 mb-4'>
        <div className='flex items-center gap-2 text-sm text-gray-700'>
         <Mail size={14}/>
          {/* <a href={`mailto:${item.email}`} className='text-blue-600 hover:underline'> */}
          <p className='text-blue-600'>  {item.email}</p>
          {/* </a> */}
        </div>
        <div className='flex items-center gap-2 text-sm text-gray-700'>
         <Phone size={14}/>
          {/* <a href={`tel:${item.phone?.replace(/\D/g, '')}`} className='hover:underline'>{item.phone}</a> */}
          <p>{item?.phoneWithCC}</p>
        </div>
      </div>

      {/* Location */}

{/* <div className='mb-4'>
  <h4 className='text-sm font-medium text-gray-700 mb-1'>Designation:</h4>
  <p className='text-sm text-gray-600 flex gap-2 items-center'>
    <FaUserTie size={16} className="text-gray-500" />
    {item.designation}
  </p>
  <p className='text-sm text-gray-600'>{item.qualification}</p>
</div> */}

      {/* Skills */}
      <div className='mb-4'>
        <h4 className='text-sm font-medium text-gray-700 mb-1'>Skills:</h4>
        <div className='flex flex-wrap gap-2'>
          {item.skills?.map((skill, index) => (
            <span key={index} className='px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded'>
              {skill}
            </span>
          ))}
        </div>
      </div>

      {/* Status */}
      {/* {item?.status && 
      <div className={`text-xs px-3 py-1 rounded-full w-fit ${
        item.status === "Active"
          ? "bg-green-100 text-green-700"
          : "bg-yellow-100 text-yellow-700"
      }`}>
        {item.status}
      </div>} */}
    </div>
  );
};

export default TeamCard;
